export default __webpack_public_path__ + "static/media/3-cn.6e574b0e.webp";